// Direct fetch-based GraphQL client to avoid URQL Federation issues
import { errorHandler } from '@/services/error-handler'
const vueAppGraphqlUrl = import.meta.env.VITE_APP_GRAPHQL_API;

export async function fetchGraphQL(query, variables = {}) {
  let apiStatus = null
  try {
    const requestBody = {
      query,
      variables,
    };

    const response = await fetch(vueAppGraphqlUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Magento-Store-View-Code": "default",
        "Magento-Website-Code": "base",
        "Magento-Store-Code": "default",
      },
      body: JSON.stringify(requestBody),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    apiStatus = response.status
    const result = await response.json();

    // Check for actual data errors vs Federation validation errors
    if (result.errors) {
      const federationErrors = result.errors.filter(
        (error) =>
          error.message.includes("_Any") ||
          error.message.includes("_entities") ||
          error.message.includes("Federation"),
      );

      const realErrors = result.errors.filter(
        (error) =>
          !error.message.includes("_Any") &&
          !error.message.includes("_entities") &&
          !error.message.includes("Federation"),
      );

      if (realErrors.length > 0) {
        // console.error("❌ GraphQL Errors:", realErrors);
        throw new Error(realErrors[0]?.message || "GraphQL Error");
      }
    }

    return result.data;
  } catch (error) {
    console.error("❌ Fetch GraphQL Error:", error);
    // send error to datadog error handler
    error.name = 'GraphQLApiError'
    error.dd_context = {
      type: 'graphql-api-error',
      status: apiStatus,
      url: vueAppGraphqlUrl,
    }
    errorHandler.send(error)
    throw error;
  }
}
